export default __webpack_public_path__ + "static/media/deposit.9fc8f542.svg";